import React from "react";
import { __ } from "@wordpress/i18n";
import { ArrowAltIcon } from "../../icons";
import { Section } from "../section";
import DevelopmentLogo from "../../images/services/development.png";
import MalwareLogo from "../../images/services/malware.png";
import MonitoringLogo from "../../images/services/monitoring.png";
import OptimizationLogo from "../../images/services/optimization.png";
import { getUtmUrl } from "../../utils/utm-url";

const SERVICES_ITEMS = [
  {
    icon: DevelopmentLogo,
    title: __("On-Demand Development", "plugin-cross-sell-textdomain"),
    description: __(
      "Our experienced WordPress developers, on-call for a simple monthly fee.",
      "plugin-cross-sell-textdomain"
    ),
    link: getUtmUrl("https://wpmudev.com/expert-services/", {utm_campaign:'cross-sell_expert_odd'}),
  },
  {
    icon: MonitoringLogo,
    title: __("Proactive Monitoring", "plugin-cross-sell-textdomain"),
    description: __(
      "Sleep better knowing we’ve got your sites covered 24/7. If your site goes offline, we’ll fix it immediately.",
      "plugin-cross-sell-textdomain"
    ),
    link: getUtmUrl("https://wpmudev.com/expert-services/", {utm_campaign:'cross-sell_expert_uptime'}),
  },
  {
    icon: OptimizationLogo,
    title: __("Speed Optimization", "plugin-cross-sell-textdomain"),
    description: __(
      "Supercharge your client’s sites, with guaranteed PageSpeed scores of 90+ on desktop and 75+ on mobile.",
      "plugin-cross-sell-textdomain"
    ),
    link: getUtmUrl("https://wpmudev.com/expert-services/", {utm_campaign:'cross-sell_expert_speed'}),
  },
  {
    icon: MalwareLogo,
    title: __("Malware Removal", "plugin-cross-sell-textdomain"),
    description: __(
      "Our malware removal service doesn’t just clean up infections - it prevents them from recurring.",
      "plugin-cross-sell-textdomain"
    ),
    link: getUtmUrl("https://wpmudev.com/expert-services/", {utm_campaign:'cross-sell_expert_security'}),  
  },
];

const Services = () => {
  return (
    <Section
      title={__("Expert services", "plugin-cross-sell-textdomain")}
      className="cross-sell-section--services"
      description={__(
        "Hand off any site issues to our WordPress expert team’s 20+ years of expertise.",
        "plugin-cross-sell-textdomain"
      )}
      tag={
        <span className="sui-tag sui-tag-yellow sui-tag-sm">
          {__("Add-on services", "plugin-cross-sell-textdomain")}
        </span>
      }
    >
      {SERVICES_ITEMS.length > 0 && (
        <div className="cross-sell-grid cross-sell-services-cards">
          {SERVICES_ITEMS.map((service) => (
            <a
              key={service.title}
              className="cross-sell-card"
              href={service.link}
              target="_blank"
            >
              <div className="cross-sell-grid__item-icon">
                <img src={service.icon} alt={service.title} />
              </div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <ArrowAltIcon className="cross-sell-card-arrow-alt" />
            </a>
          ))}
        </div>
      )}
    </Section>
  );
};

export { Services };
